import React from 'react';
import {
  arrayOf, shape, string, func, number, oneOf
} from 'prop-types';
import { MAX_DISPLAYED_HOTSPOTS_COUNT, HOTSPOT_TYPE } from '../../constants';
import { ShowRelatedItems } from './ShowRelatedItems';
import { LifeStyleHotspot } from './LifeStyleHotspot';
import './styles/hotspot.scss';

const LifestyleImageWithHotspot = ({
  hotspots, imageUrl, tagIndex, imgOnclick, onClickHandler, mediaGalleryIndex, type, onShowFirstTagProduct
}) => {

  return (
    <div className="product-hotspots sui-relative" data-component="MediaHotspots">
      <img
        alt="lifestyleimage"
        className="sui-w-full sui-h-full"
        src={imageUrl}
        height="1"
        width="1"
        onClick={imgOnclick}
        aria-label="lifestyleImage"
      />
      {hotspots.length > 0
        && type === HOTSPOT_TYPE.PIP_HOTSPOTS && <ShowRelatedItems showFirstTagProduct={onShowFirstTagProduct} />}
      {hotspots.length > 0 && hotspots.slice(0, MAX_DISPLAYED_HOTSPOTS_COUNT).map((hotspot, index) => {
        const { coordinate, omsIDs } = hotspot;
        return (
          <div
            id={`drawer-wrapper-div-${index}`}
            key={type === HOTSPOT_TYPE.PIP_HOTSPOTS ? mediaGalleryIndex + '-' + index : index}
          >
            <LifeStyleHotspot
              xCoordinate={coordinate.xCoordinate}
              yCoordinate={coordinate.yCoordinate}
              omsIDs={omsIDs}
              index={index}
              currentTagIndex={tagIndex}
              type={type}
              onClickHandler={() => onClickHandler(type === HOTSPOT_TYPE.PIP_HOTSPOTS ? true : omsIDs, index)}
            />
          </div>
        );
      })}
    </div>
  );
};

LifestyleImageWithHotspot.displayName = 'LifestyleImageWithHotspot';

LifestyleImageWithHotspot.propTypes = {
  hotspots: arrayOf(shape({
    coordinate: shape({
      xCoordinate: string,
      yCoordinate: string
    }),
    omsIDs: arrayOf(string)
  })).isRequired,
  imageUrl: string.isRequired,
  tagIndex: number,
  imgOnclick: func,
  onClickHandler: func,
  type: oneOf([HOTSPOT_TYPE.PIP_HOTSPOTS, HOTSPOT_TYPE.DRAWER_HOTSPOTS]),
  mediaGalleryIndex: number,
  onShowFirstTagProduct: func
};

LifestyleImageWithHotspot.defaultProps = {
  imgOnclick: null,
  onClickHandler: null,
  tagIndex: 0,
  type: HOTSPOT_TYPE.PIP_HOTSPOTS,
  mediaGalleryIndex: 0,
  onShowFirstTagProduct: null
};

export { LifestyleImageWithHotspot };
